// benefit custom slider js start //
document.addEventListener('DOMContentLoaded', function() {
  var slider = document.querySelector('.collection-list-new');
  var isDragging = false;
  var startX, scrollLeft;

  // Handle mouse events for dragging
  slider.addEventListener('mousedown', function(e) {
    isDragging = true;
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;

    // Disable text selection during drag
    slider.style.cursor = 'grabbing';
    slider.style.userSelect = 'none';
  });

  slider.addEventListener('mousemove', function(e) {
    if (!isDragging) return;
    e.preventDefault();
    var x = e.pageX - slider.offsetLeft;
    var walk = (x - startX) * 1.5; // Adjust sensitivity
    slider.scrollLeft = scrollLeft - walk;
  });

  slider.addEventListener('mouseup', function() {
    isDragging = false;

    // Re-enable text selection after drag
    slider.style.cursor = 'grab';
    slider.style.userSelect = 'auto';
  });

  slider.addEventListener('mouseleave', function() {
    if (!isDragging) return;
    isDragging = false;

    // Re-enable text selection after drag
    slider.style.cursor = 'grab';
    slider.style.userSelect = 'auto';
  });

  // Handle click events to open detail page
  var items = document.querySelectorAll('.collection-list__item');
  items.forEach(function(item) {
    item.addEventListener('click', function() {
      // Navigate to the detail page based on item's data or ID
      var itemId = item.getAttribute('id'); // Example: Slide-1-2
      var detailUrl = '/detail-page?id=' + itemId; // Example URL

      // Simulate navigation to detail page (replace with actual navigation code)
      console.log('Navigating to:', detailUrl);
      // window.location.href = detailUrl; // Uncomment to enable actual navigation
    });
  });

  // Disable native drag-and-drop behavior on the slider
  slider.addEventListener('dragstart', function(e) {
    e.preventDefault();
  });
});
// 
document.addEventListener('DOMContentLoaded', function() {
   setTimeout(function() {
      if (document.body.classList.contains('account')) {
          document.body.classList.remove('account');
      }
  }, 5);
   setTimeout(function() {
      if (document.body.classList.contains('addresses')) {
          document.body.classList.remove('addresses');
      }
  }, 5);
});



//globo filter add link show-more script.
$(document).ready(function() {
    // Event listener for clicking on .demo-test links
    $(document).on('click', '.demo-test', function() {
        // Find the parent .gf-option-block container
        var $optionBlock = $(this).closest('.gf-option-block');
        
        // Find the .gf-scroll element within the same .gf-option-block
        var $scrollElement = $optionBlock.find('.gf-scroll');
        
        // Expand the max-height of .gf-scroll to show all content
        $scrollElement.css('max-height', '100%');
        
        // Hide the clicked .demo-test link
        $(this).hide();
    });
});


// benefit custom slider js end //


$(document).ready(function() {
   $('.sea-moss-sectionn-main .home-slider-see-moss').owlCarousel({
		loop: true,
	    margin: 25,
        // navText: ["<i class=\"fa-solid fa-arrow-left\"></i>","sdasddasd<i class=\"fa-solid fa-arrow-right\"></i>"],
		items:1,
        slideBy:5,
		// autoplay: true,
        nav:true,
        autoplayTimeout: 4000,
        smartSpeed: 500,
		dots: false,
		dotsEach: 1,
		responsiveClass: true,
        autoHeight: false,
        responsiveBaseElement: 'body',
		responsive: {
		  0: {
			items: 2.2,
			nav: true,
            margin: 10,
		  },
          390:{
            items: 2.2,
			nav: true,
            margin: 10,
          },
          480:{
            items: 2,
			nav: true,
          },
          600:{
            items: 2,
			nav: true,
          },
          880:{
            items: 3,
			nav: true
          },
          991:{
            items: 3,
			nav: true
          },
         1180:{
            items: 4,
			nav: true,
          },
          1440:{
            items: 5,
			nav: true
          } 
		}
	});
  
 });

//home-sea-moss-owl-slider script...
$('.sea-moss-sectionn-main .btn-flex1 .left-arrow1').click(function(e) {
    e.preventDefault();
    $(this).closest('.sea-moss-sectionn-main').find('.owl-prev').trigger('click');
})

$('.sea-moss-sectionn-main .btn-flex1 .right-arrow1').click(function(e) {
    e.preventDefault();
    $(this).closest('.sea-moss-sectionn-main').find('.owl-next').trigger('click');
})




// home-collection slider.....
$(document).ready(function() {
   $('.Best.Selling .home-slider').owlCarousel({
		loop: true,
	    margin: 25,
        // navText: ["<i class=\"fa-solid fa-arrow-left\"></i>","sdasddasd<i class=\"fa-solid fa-arrow-right\"></i>"],
		items:1,
        slideBy:5,
		// autoplay: true,
        nav:false,
        autoplayTimeout: 4000,
        smartSpeed: 500,
		dots: false,
		dotsEach: 1,
		responsiveClass: true,
        autoHeight: false,
        responsiveBaseElement: 'body',
		responsive: {
		  0: {
			items: 2.2,
			nav: false,
            margin: 10,
		  },
          390:{
            items: 2.2,
			nav: false,
            margin: 10,
          },
          480:{
            items: 2,
			nav: false,
          },
          600:{
            items: 2,
			nav: false,
          },
          880:{
            items: 3,
			nav: false
          },
          991:{
            items: 3,
			nav: false
          },
         1180:{
            items: 4,
			nav: true,
          },
          1440:{
            items: 5,
			nav: true
          } 
		}
	})
 })
// owl-slider script...

$('.Best.Selling .btn-flex .left-arrow').click(function(e) {
    e.preventDefault();
    $(this).closest('.Best.Selling').find('.owl-prev').trigger('click');
})

$('.Best.Selling .btn-flex .right-arrow').click(function(e) {
    e.preventDefault();
    $(this).closest('.Best.Selling').find('.owl-next').trigger('click');
})



//home collection....
$(document).ready(function(){
    $('.collection-slider').owlCarousel({
      loop: true,
      margin: 25,
      nav: false,
      dots: false,
      responsive:{
          0:{
              items:1.2
          },
          600:{
              items:2.3
          },
          991:{
              items:3.3,  
          },
          1440:{
             items:4.3,  
			nav: true
          }
          
      }
    });

var isScrolling = false;
  var owl = $('.collection-slider'); // Target the specific carousel instance

  // Handle wheel event for scrolling in specific Owl Carousel
  owl.on('wheel', '.owl-stage', function (e) {
    e.preventDefault();

    if (!isScrolling) {
      isScrolling = true;

      // Calculate scroll direction and number of items to move
      var delta = e.originalEvent.deltaY || -e.originalEvent.wheelDelta;
      var moveCount = 4; // Number of items to move per scroll

      // Determine scroll direction and adjust moveCount accordingly
      if (delta < 0) {
        owl.trigger('prev.owl.carousel', moveCount);
      } else {
        owl.trigger('next.owl.carousel', moveCount);
      }

      // Delay to prevent rapid scrolling
      setTimeout(function() {
        isScrolling = false;
      }, 300); // Adjust delay timing as needed
    }
  });
  
});




$(function() {
 $(document).ready(function() {
        $('.plus-faq .accordion-item').click(function() {
            var $panel = $(this).find('.plus-faq .panel');
            $('.plus-faq .panel').not($panel).slideUp(400, 'swing');
            $(this).toggleClass('open');
            $panel.stop(false, true).slideToggle(400, 'swing');
        });
    });
});


// homepage slider arrow script
$('body.index .collection .btn-flex button.left-arrow').click(function(){
    $(this).find('img').prop('src','https://cdn.shopify.com/s/files/1/0002/8308/2771/files/right-arr_1_1.png?v=1724741796');
    $('body.index .collection .btn-flex button.right-arrow').find('img').prop('src','https://cdn.shopify.com/s/files/1/0002/8308/2771/files/left-arr_1_1.png?v=1724741796');
});
$('body.index .collection .btn-flex button.right-arrow').click(function(){
    $(this).find('img').prop('src','https://cdn.shopify.com/s/files/1/0002/8308/2771/files/right-arr_1.png?v=1723015452');
    $('body.index .collection .btn-flex button.left-arrow').find('img').prop('src','https://cdn.shopify.com/s/files/1/0002/8308/2771/files/left-arr_1.png?v=1721642723');
});
$('body.index .collection .btn-flex1 button.left-arrow1').click(function(){
    $(this).find('img').prop('src','https://cdn.shopify.com/s/files/1/0002/8308/2771/files/right-arr_1_1.png?v=1724741796');
    $('body.index .collection .btn-flex1 button.right-arrow1').find('img').prop('src','https://cdn.shopify.com/s/files/1/0002/8308/2771/files/left-arr_1_1.png?v=1724741796');
});
$('body.index .collection .btn-flex1 button.right-arrow1').click(function(){
    $(this).find('img').prop('src','https://cdn.shopify.com/s/files/1/0002/8308/2771/files/right-arr_1.png?v=1723015452');
    $('body.index .collection .btn-flex1 button.left-arrow1').find('img').prop('src','https://cdn.shopify.com/s/files/1/0002/8308/2771/files/left-arr_1.png?v=1721642723');
});

$(document).on('click','.frequently-asked-questions .accordion',function(e){
  $(this).toggleClass('active');
});


// Fore SEO Pages
$(document).ready(function() {
  $('.faq-collapsable-title').click(function() {
  const $this = $(this);
  const $parent = $this.closest('.faq-collapsable-content');
  const $content = $parent.find('.faq-expandable-content');

  if ($parent.hasClass('active')) {
    $content.stop(true, true).slideUp();
    $parent.removeClass('active');
  } else {
    $('.faq-collapsable-content').removeClass('active')
      .find('.faq-expandable-content').slideUp();
    $parent.addClass('active');
    $content.stop(true, true).slideDown();
  }
});
  });